import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../../theme'

const styles = StyleSheet.create({
    container: {
        backgroundColor: 'white',
        flexDirection: 'column',
    },
    containerFlex: {
        flex: 1,
    },
    opacity: {
        opacity: 1,
    },
    overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        zIndex: 0,
    },
})

export default styles
